import { render, staticRenderFns } from "./Giros.vue?vue&type=template&id=39660b27&scoped=true"
import script from "./Giros.vue?vue&type=script&lang=js"
export * from "./Giros.vue?vue&type=script&lang=js"
import style0 from "./Giros.vue?vue&type=style&index=0&id=39660b27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39660b27",
  null
  
)

export default component.exports